import { CiLocationOn } from "react-icons/ci";
import { MdOutlineMailOutline } from "react-icons/md";
import { FiPhone } from "react-icons/fi";
import ContactForm from "../component/ContactForm";

const Contact = () => {
  return (
    <section className="max-w-[1200px] mx-auto px-6 py-20">
      {/* Header */}
      <div className="text-center mb-16">
        <h1 className="text-[42px] font-semibold text-gray-900 mb-4">
          Get in Touch
        </h1>
        <p className="text-gray-500 text-lg">
          Let’s connect and bring your vision to life together
        </p>
      </div>

      {/* Divider */}
      <div className="flex items-center justify-center mb-20">
        <div className="w-full border-t border-gray-200"></div>
        <h2 className="px-6 text-sm tracking-widest text-black whitespace-nowrap font-bold relative">
          LET’S MAKE SOMETHING GREAT
          <span className="absolute -top-2 left-1/2 -translate-x-1/2 w-2 h-2 bg-primary rounded-full"></span>
        </h2>
        <div className="w-full border-t border-gray-200"></div>
      </div>

      {/* Contact Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-20">
        <div className="bg-white rounded-2xl shadow-md p-8 hover:shadow-xl transition">
          <div className="flex items-center gap-3 mb-4 text-primary">
            <FiPhone size={28} />
            <h3 className="font-semibold tracking-wide  font-clash">PHONE</h3>
          </div>
          <a
            href="tel:+919363959787"
            className="inline-block  rounded-lg  hover:text-primary transition font-aileron font-medium"
          >
            +91 9363 95 9787
          </a>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-8 hover:shadow-xl transition">
          <div className="flex items-center gap-3 mb-4 text-primary">
            <MdOutlineMailOutline size={28} />
            <h3 className="font-semibold tracking-wide font-aileron">E-MAIL</h3>
          </div>
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=info@azerotech.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-800 hover:text-primary transition font-medium font-clash"
          >
            info@azerotech.com
          </a>
        </div>
        {/* Address */}
        <div className="bg-white rounded-2xl shadow-md p-8 hover:shadow-xl transition">
          <div className="flex items-center gap-3 mb-4 text-primary">
            <CiLocationOn size={28} />
            <h3 className="font-semibold font-clash tracking-wide">
              ADDRESS
            </h3>
          </div>
        <a href="https://maps.app.goo.gl/vxYZmwGp58E74tGK9" target="_black">
            <p className="text-gray-600 leading-relaxed font-normal font-aileron hover:text-primary cursor-pointer" >
            Kangayanellore Rd,  
            Viruthampattu, Vellore, Tamil Nadu 632006
          </p> 
        
        </a>
        </div>
      </div>

      <ContactForm />

      <div className="flex justify-center items-center h-[420px] w-full">
        <div className="w-full rounded-2xl overflow-hidden shadow-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.382972275288!2d79.13566287484093!3d12.947328287365758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad475bf3927617%3A0xb9755066adabbb3d!2sAzero%20Tech!5e0!3m2!1sen!2sin!4v1768292992781!5m2!1sen!2sin"
            className="w-full h-[420px]"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;
